import { Box, Button, Chip, Stack, Typography } from '@mui/material';

export function LeadCampaignActionsBar({ campaign, onSend, onPrepare, onRetry, onCancel }) {

    if (!campaign) return null;

    const canSend = campaign.canSend === true;
    const recipientCount = campaign.recipientCount ?? 0;

    return (
        <Box
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 10,
                bgcolor: '#fff',
                borderBottom: '1px solid #eee',
                p: 2
            }}
        >
            <Stack direction="row" justifyContent="space-between" alignItems="center">

                {/* STATUS */}
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography>وضعیت:</Typography>

                    <Chip
                        label={campaign.statusLabel || campaign.status}
                        color={
                            campaign.status === 'Running'
                                ? 'success'
                                : campaign.status === 'Draft'
                                    ? 'warning'
                                    : 'default'
                        }
                    />

                    <Chip
                        label={`گیرنده‌ها: ${recipientCount}`}
                        variant="outlined"
                    />
                </Stack>

                {/* ACTIONS */}
                <Stack direction="row" spacing={1}>

                    <Button
                        variant="outlined"
                        onClick={onPrepare}
                        disabled={campaign.status === 'Running'}
                    >
                        آماده‌سازی
                    </Button>

                    <Button
                        variant="contained"
                        onClick={onSend}
                        disabled={!canSend}
                    >
                        ارسال کمپین
                    </Button>

                    <Button
                        variant="outlined"
                        color="warning"
                        onClick={onRetry}
                        disabled={!campaign.hasFailedRecipients}
                    >
                        ارسال مجدد
                    </Button>

                    <Button
                        variant="text"
                        color="error"
                        onClick={onCancel}
                        disabled={campaign.status === 'Cancelled'}
                    >
                        توقف
                    </Button>

                </Stack>
            </Stack>
        </Box>
    );
}